// @flow

import React from 'react';
import PropTypes from 'prop-types';
import CustomModal from '../../../../elements/CustomModal/CustomModal';
import {makeStyles, Typography} from '@material-ui/core';
import {colors} from '../../../../assets/styles/colors';
import CustomButton from '../../../../elements/CustomButton/CustomButton';

import type {Theme} from '@material-ui/core';

type Props = {
  open: boolean,
  handleClose: () => void,
  onClick: () => void,
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    maxWidth: 500,
    padding: theme.spacing(4, 1, 4, 1),
  },
  title: {
    color: colors.grey1000,
    fontSize: 22,
    fontWeight: 600,
  },
  infoText: {
    color: colors.grey800,
    fontSize: 16,
  },
  infoTextWrap: {
    margin: theme.spacing(2, 0),
  },
}));

export default function AddCardRedeemModal(props: Props) {
  const {open, handleClose, onClick} = props;
  const classes = useStyles();

  return (
    <CustomModal open={open} handleCloseModal={handleClose}>
      <div className={classes.root}>
        <Typography className={classes.title} align="center">
          Debes agregar una tarjeta para canjear una suscripción.
        </Typography>

        <div className={classes.infoTextWrap}>
          <Typography className={classes.infoText} align="center">
            No te preocupes, no se realizará un cobro{' '}
            <span role="img" aria-label="emoji">
              😉
            </span>
            .
            <br />
            Tu nueva suscripción se renovará con tus puntos.
          </Typography>
        </div>
        <CustomButton fullWidth variant="outlined" onClick={onClick}>
          Agregar una tarjeta
        </CustomButton>
      </div>
    </CustomModal>
  );
}

AddCardRedeemModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
};
